var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveDrone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1191 18.4326C35.8063 18.6345 36.285 19.2698 36.2852 19.9873V22.3643C36.2851 23.1564 35.8847 23.6094 35.377 23.8213L35.3418 23.8359L35.3076 23.8545C35.1753 23.9262 34.9738 23.9873 34.6738 23.9873H31.4365V27.5098C31.4365 28.4434 30.89 29.2617 30.0947 29.6533L29.3008 30.0449L29.8174 30.7646C30.2782 31.4056 30.5296 31.8749 30.6807 32.4531C30.8038 32.9245 30.8656 33.4957 30.8877 34.3232H30.4092C30.3865 33.4416 30.3126 32.7925 30.1104 32.2158C29.8523 31.4801 29.405 30.9177 28.8184 30.1797L28.5938 29.8965H19.751L19.5264 30.1797C18.9398 30.9176 18.4916 31.4801 18.2334 32.2158C18.0311 32.7924 17.9573 33.4417 17.9346 34.3232H17.4561C17.4782 33.4958 17.5409 32.9245 17.6641 32.4531C17.8151 31.8749 18.0657 31.4052 18.5264 30.7646L19.0439 30.0449L18.249 29.6533C17.4535 29.2617 16.9082 28.4433 16.9082 27.5098V23.9873H13.6689C13.369 23.9872 13.1676 23.9264 13.0352 23.8545L13.002 23.8359L12.9658 23.8213L12.7822 23.7305C12.3658 23.4911 12.0586 23.0573 12.0586 22.3643V19.9873C12.0587 19.2698 12.5375 18.6345 13.2246 18.4326L13.6797 18.2988L14.1348 18.4326C14.8215 18.6341 15.2997 19.2701 15.2998 19.9873V21.2471H16.0498L32.2939 21.2461H33.0439V19.9873C33.0441 19.27 33.5225 18.6341 34.209 18.4326L34.6641 18.2988L35.1191 18.4326ZM24.1719 22.8604C22.9178 22.8605 21.9014 23.8776 21.9014 25.1318C21.9016 26.3859 22.9179 27.4022 24.1719 27.4023C25.426 27.4023 26.4431 26.386 26.4434 25.1318C26.4434 23.8775 25.4262 22.8604 24.1719 22.8604Z",
    stroke: "#0F5EFF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDrone);
export default __webpack_public_path__ + "static/media/activeDrone.5e46709f22e21002f7bb181aab86211f.svg";
export { ForwardRef as ReactComponent };